module.exports = __webpack_public_path__ + "static/media/SVGPrivacy.266ae83b.svg";